import React, { Component } from 'react';
import { ThemeProvider, injectGlobal } from 'styled-components';

import '@fitbit/proxima-nova-font';
import SettingsStorage from './lib/settings-storage';
import { Page, Screen } from './components/Common';
import Navbar from './components/navbar';
import theme, { isThemeiOS, androidNavbarHeight, iOSNavbarHeight } from './themes';

// eslint-disable-next-line
injectGlobal`
  ${theme.global}
`;

const SettingsContext = React.createContext({});

export const SettingsContextChild = SettingsContext.Consumer;

export default class SettingsRuntime extends Component {
  state = {
    settings: {},
    scrolling: false
  };

  getContextValue() {
    return {
      settings: this.state.settings,
      settingsStorage: this.settingsStorage
    };
  }

  updateSettings = (settings: *): void => {
    this.setState((state): State =>
      Object.assign({}, state, {
        settings
      })
    );
  };

  _onChange = () => {
    const newSettings: JsonObject = this.settingsStorage._toJS();
    this.updateSettings(newSettings);
  }

  onNotify = (changeType: *, event: *): void => {
    this._onChange();

    this.props.triggerChange(changeType, event);
  };

  componentWillMount() {
    let storedSettings = this.props.settingsData || {};
    this.updateSettings(storedSettings);
    this.settingsStorage = SettingsStorage(storedSettings, this.onNotify);

    this.props.notifyChange((changeType, { key, oldValue, newValue }) => {
      if (changeType === 'set') {
        this.settingsStorage.setItem(key, newValue, false);
      } else if (changeType === 'remove') {
        this.settingsStorage.removeItem(key, false);
      } else if (changeType === 'clear') {
        this.settingsStorage.clear(false);
      }

      this._onChange();
    });
  }

  componentWillReceiveProps({ settingsData }) {
    if (settingsData) {
      this.updateSettings(settingsData);
    }
  }

  setupSettingsPage = () => {
    const { settings } = this.state;
    const { settingsStorage } = this;
    return React.createElement(this.props.settingsPage, {
      settings,
      settingsStorage
    });
  };

  onScroll = ({ scrolling = false }) => {
    if (this.state.scrolling === scrolling) {
      return;
    }
    this.setState({
      scrolling
    });
  };

  render() {
    const navbarHeight = isThemeiOS() ? iOSNavbarHeight : androidNavbarHeight;
    return (
      <SettingsContext.Provider value={this.getContextValue()}>
        <ThemeProvider theme={theme}>
          <Screen>
            <Navbar scrolling={this.state.scrolling} />
            <Page navbarHeight={navbarHeight} onScroll={this.onScroll}>
              {this.setupSettingsPage()}
            </Page>
          </Screen>
        </ThemeProvider>
      </SettingsContext.Provider>
    );
  }
}




// WEBPACK FOOTER //
// ./src/settings-runtime.js